import { render, staticRenderFns } from "./AppNavigationComponent.vue?vue&type=template&id=360c631d&scoped=true&"
import script from "./AppNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./AppNavigationComponent.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationComponent.vue?vue&type=style&index=0&id=360c631d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c631d",
  null
  
)

export default component.exports